<template>
  <v-layout
    :class="icon ? 'icon-mode' : ''"
    row
    wrap>
    <v-flex
      xs12
      class="px-0"
    >
      <v-btn
        v-if="!icon"
        flat
        block
        small
        class="text-capitalize"
        @click.stop="show = true"
      >
        <span class="d-block">{{ $t('Price tiers') }}</span>
        <v-spacer/>
        <v-icon class="d-block">keyboard_arrow_right</v-icon>
      </v-btn>
      <v-btn
        v-else
        icon
        class="text-capitalize mx-1"
        color="secondary"
        small
        @click.stop="show = true"
      >
        <v-icon small>payments</v-icon>
      </v-btn>
    </v-flex>

    <v-dialog
      v-model="show"
      width="400"
    >
      <v-card>
        <v-card-title>
          <h4>{{ $t('Applicable Tier Prices') }}</h4>
          <v-spacer/>
          <v-btn
            icon
            @click.stop="show = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn
            v-for="(tier, index) in tiers"
            :key="index"
            :class="tier === selected ? 'primary' : ''"
            class="my-1"
            block
            large
            flat
          >
            <span class="d-block">{{ tier.quantity }} - {{ tier.nextQuantity || '&#8734;' }} </span>
            <v-spacer/>
            <span class="d-block">{{ tier.gross_price || tier.price | money }}</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ItemTiersList',

  props: {
    tierPrices: {
      type: Array,
      required: true
    },
    noArrow: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number,
      default: undefined
    },
    icon: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      show: false
    }
  },

  computed: {
    tiers () {
      const tierPrices = this.tierPrices
      tierPrices.sort((a, b) => a.quantity - b.quantity)

      return tierPrices.map((t, i) => {
        t.selected = false
        const nextTier = tierPrices[i + 1] || null
        t.nextQuantity = nextTier ? nextTier.quantity - 1 : null
        return t
      })
    },
    selected () {
      if (!this.quantity) {
        return null
      }
      return this.tierPrices.slice().sort((a, b) => b.quantity - a.quantity).find(t => this.quantity >= t.quantity)
    }
  }
}
</script>

<style>
.icon-mode {
  display: inline-block;
  margin-left: 5px !important;
  margin-right: 5px !important;
}
</style>
